import { ModalProp } from "../../components/modal/Modal";
import { ConfirmModal } from "./ConfirmModal";

export type DeleteConfirmationModalProps = {
  handle: () => Promise<void>;
  title?: any;
  body?: any;
}

export const DeleteConfirmationModal = ({
  open,
  toggle,
  closeOnClickOutside,
  handle,
  title,
  body,
}: ModalProp & DeleteConfirmationModalProps) => {
  return (
    <>
      <ConfirmModal 
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
        handle={handle}
        children
        contentType={"delete"}
        title={title}
        body={body}
      />
    </>
  );
};